import React from 'react'
import {formatInZone, zoneNotice} from 'helpers/datetime'
import {Col, Row, List, Tag, Typography} from 'antd'
import {Spin} from 'antd'
import {useQuery} from 'react-query'

import Item from './Item'
import * as gopherOfferQueries from '../../../queries/gopheroffer.queries'
import * as Styled from './counterview.styled'
import Link from 'components/SafeLink'

const {Title} = Typography

function GopherOfferView({params}) {
    const gopherOfferQuery = useQuery(
        ['id', params.id],
        gopherOfferQueries.getGopherOfferById,
    )

    const gopher_offer = gopherOfferQuery.data?.data.data

    /* G40-456: render this record's times on the clock they belong to — the
       order's, supplied by the API, or the operator's when the record has no
       order behind it. `zoneLine` names which, and says when it was inferred. */
    const fmt = (value, options = {}) =>
        formatInZone(value, gopher_offer?.order_timezone, options)
    const zoneLine = zoneNotice(
        gopher_offer?.order_timezone,
        gopher_offer?.order_timezone_source,
    )

    // console.log(gopherOfferQuery.data?.data.data)
    if (gopherOfferQuery.isLoading) {
        return (
            <Styled.Root>
                <Spin />
            </Styled.Root>
        )
    }

    return (
        <>
            {/* G40-456 zone caption — say whose clock these times are on */}
            <div
                style={{
                    fontSize: '85%',
                    opacity: 0.75,
                    margin: '0 0 10px 8px',
                }}>
                {zoneLine}
            </div>
            <div className="order">
                <Col className="order_col">
                    <List
                        size="small"
                        bordered
                        style={{
                            background: 'rgba(0,0,0,0.03)',
                            paddingTop: '1.05rem',
                        }}
                        header={<Title level={5}>Basic Info</Title>}>
                        <Item body={gopher_offer.id} title="ID#" />
                        <Item
                            body={
                                <Link to={`/booking/${gopher_offer.order_id}`}>
                                    {gopher_offer.order_id}
                                </Link>
                            }
                            title="Order ID "
                        />
                        <Item body={gopher_offer.title} title="Title" />
                        <Item
                            body={
                                <Link to={`/user/${gopher_offer.gopher_id}`}>
                                    {gopher_offer.gopher}
                                </Link>
                            }
                            title="Gopher Name"
                        />
                        <Item
                            body={
                                <Link to={`/user/${gopher_offer.requestor_id}`}>
                                    {gopher_offer.requestor}
                                </Link>
                            }
                            title="Requestor Name"
                        />
                        <Item
                            body={
                                gopher_offer.status === 'Declined' ? (
                                    <Tag color="red">{gopher_offer.status}</Tag>
                                ) : gopher_offer.status === 'Accepted' ? (
                                    <Tag color="green">
                                        {gopher_offer.status}
                                    </Tag>
                                ) : (
                                    <Tag color="blue">
                                        {gopher_offer.status}
                                    </Tag>
                                )
                            }
                            title="Status"
                        />
                        <Item
                            body={fmt(gopher_offer.createdon, {dateOnly: true})}
                            title="Created On"
                        />
                    </List>
                </Col>
            </div>
        </>
    )
}

export default GopherOfferView
